import { getOrCreateSignifydSessionId } from "@/lib/auth";
import { useCreatePaymentMutation } from "@/redux/apiSlices/paymentApi";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

const usePaypalPayment = () => {
  const router = useRouter();
  const [
    createPayment,
    { data, isSuccess, isLoading: isPaymentLoading, isError: isPaymentError },
  ] = useCreatePaymentMutation();

  useEffect(() => {
    if (isSuccess && data?.success && data?.statusCode === 200) {
      const { redirectUrl } = data || {};
      if (redirectUrl) {
        router.push(redirectUrl);
      }
    }
    if (isPaymentError) {
      // setIsDisableCheckout(false);
    }
  }, [isSuccess, data, router, isPaymentError]);

  const paypalPaymentHandler = async (orderId) => {
    const res = await fetch("/api/get-ip");
    const { ip } = await res.json();
    const sessionId = getOrCreateSignifydSessionId();

    const obj = {
      orderId,
      clientIp: ip,
      sessionId,
    };
    
    createPayment(obj);
  };
  return { paypalPaymentHandler, isPaymentLoading };
};

export default usePaypalPayment;
